<template>
  <div class="view login">
        <div class="view-content">
          <div class="container">
            <div class="view-content">
                <h1 class="view-content-title h1">
                    {{ $t('no_exhibition.title') }}
                </h1>
                <p class="view-content-text">{{ $t('no_exhibition.text') }}</p>
            </div>
          </div>
        </div>
  </div>
</template>

<script>
export default {
};
</script>

<style lang="scss" scoped>
.view {
  position: relative;
  padding-top: 100px;
  background-color: $primary;

  &-content {
    position: relative;
    .container {
      padding: 0 20px 20px;
    }
    &-title {
        @include margin(null null 10px);
    }
    &-text {
        @include margin(null null 20px);
    }
  }
}
</style>
